import * as React from 'react';
import Flag from '../assets/Flag';
import Football from '../assets/Football';
import Lightbulb from '../assets/Lightbulb';
import Pizza from '../assets/Pizza';
import Plane from '../assets/Plane';
import Smile from '../assets/Smile';
import Trees from '../assets/Trees';
import Ban from '../assets/Ban';
import Users from '../assets/Users';
import Search from '../assets/Search';
import Close from '../assets/Close';
import Clock from '../assets/Clock';
import { exhaustiveTypeCheck } from '../utils';
import QuestionMark from '../assets/QuestionMark';
export const Icon = ({
  iconName,
  isActive,
  normalColor,
  activeColor
}) => {
  const color = isActive ? activeColor : normalColor;

  switch (iconName) {
    case 'Smile':
      return /*#__PURE__*/React.createElement(Smile, {
        fill: color
      });

    case 'Trees':
      return /*#__PURE__*/React.createElement(Trees, {
        fill: color
      });

    case 'Pizza':
      return /*#__PURE__*/React.createElement(Pizza, {
        fill: color
      });

    case 'Plane':
      return /*#__PURE__*/React.createElement(Plane, {
        fill: color
      });

    case 'Football':
      return /*#__PURE__*/React.createElement(Football, {
        fill: color
      });

    case 'Lightbulb':
      return /*#__PURE__*/React.createElement(Lightbulb, {
        fill: color
      });

    case 'Flag':
      return /*#__PURE__*/React.createElement(Flag, {
        fill: color
      });

    case 'Ban':
      return /*#__PURE__*/React.createElement(Ban, {
        fill: color
      });

    case 'Users':
      return /*#__PURE__*/React.createElement(Users, {
        fill: color
      });

    case 'Search':
      return /*#__PURE__*/React.createElement(Search, {
        fill: color
      });

    case 'Close':
      return /*#__PURE__*/React.createElement(Close, {
        fill: color
      });

    case 'Clock':
      return /*#__PURE__*/React.createElement(Clock, {
        fill: color
      });

    case 'QuestionMark':
      return /*#__PURE__*/React.createElement(QuestionMark, {
        fill: color
      });

    default:
      exhaustiveTypeCheck(iconName);
      return null;
  }
};
//# sourceMappingURL=Icon.js.map